import { NavLink } from 'react-router-dom';

const navLinks = [
  { to: '/dashboard', labelFull: 'Dashboard', labelShort: 'Home', page: 'dashboard' },
  { to: '/active', labelFull: 'Active Visits', labelShort: 'Active', page: 'active' },
  { to: '/upcoming', labelFull: 'Upcoming Visits', labelShort: 'Upcoming', page: 'upcoming' },
  { to: '/past', labelFull: 'Past Visits', labelShort: 'Past', page: 'past' },
  { to: '/chat', labelFull: 'SMS Messages', labelShort: 'SMS', page: 'chat', newTab: true },
];

export function Navbar() {
  return (
    <nav id="navbar" className="navbar" aria-label="Main navigation">
      {navLinks.map((link) => (
        <NavLink
          key={link.page}
          to={link.to}
          className={({ isActive }) =>
            `navbar__link${isActive ? ' navbar__link--active' : ''}`
          }
          data-page={link.page}
          {...(link.newTab ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
        >
          <span className="navbar__label-full">{link.labelFull}</span>
          <span className="navbar__label-short">{link.labelShort}</span>
        </NavLink>
      ))}
    </nav>
  );
}
